import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=5e4caeff&scoped=true&"
var script = {}
import style0 from "./Products.vue?vue&type=style&index=0&id=5e4caeff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4caeff",
  null
  
)

export default component.exports